import { createSlice } from '@reduxjs/toolkit';

const termsSlice = createSlice({
  name: 'terms',
  initialState: {
    nationList: [],
    termsContents: [],
    privacyPolicy: [],
    useTerms: [],
    residenceCntry: { value: 'KR' },
    trmsCd: {},
    currentVersion: 0,
    isSuccese: null,
    isUpdatePolicy: null,
    epid: null,
  },
  reducers: {
    getNationList: () => {},
    getNationListSuccess: (state, { payload }) => {
      state.nationList = payload;
    },
    getTermsContents: () => {},
    getTermsContentsSuccess: (state, { payload }) => {
      state.termsContents.push(payload.trmsCns[0]);
    },
    getPrivacyPolicy: () => {},
    getPrivacyPolicySuccess: (state, { payload }) => {
      state.privacyPolicy = payload.trmsCns;
    },
    getUseTerms: () => {},
    getUseTermsSuccess: (state, { payload }) => {
      state.useTerms = payload.trmsCns;
    },
    getUseTermsVersion: () => {},
    getUseTermsVersionSuccess: (state, { payload }) => {
      state.trmsCd = payload;
      state.currentVersion = payload.trmsVerVals.length - 1;
    },
    getCountryTerms: state => {
      state.termsContents = [];
    },
    getCountryTermsSuccess: (state, { payload }) => {
      state.termsContents = payload.trmsCns.filter(term => term.ncsrYn === 'Y');
    },
    setResidenceCntry: (state, { payload }) => {
      state.residenceCntry = payload;
    },
    setTermsEpid: (state, { payload }) => {
      state.epid = payload;
    },
    getTermsPolicy: state => {
      state.trmsCd = {};
    },
    getTermsPolicySuccess: (state, { payload }) => {
      state.trmsCd = payload;
      state.currentVersion = payload.trmsVerVals.length - 1;
    },
    getTermsPolicyFail: (state, { payload }) => {
      state.trmsCd = payload;
    },
    setCurrentVersion: (state, { payload }) => {
      if (payload > -1 && payload < state.trmsCd.trmsVerVals?.length) state.currentVersion = payload;
    },
    createTermsAgreement: state => {
      state.isSuccese = false;
    },
    createTermsAgreementSuccess: (state, { payload }) => {
      state.isSuccese = payload.result === 'success';
    },
    updatePrivacy: state => {
      state.isUpdatePolicy = false;
    },
    updatePrivacySuccess: (state, { payload }) => {
      state.isUpdatePolicy = true;
    },
    updatePrivacyFail: (state, { payload }) => {},
    getTermsVersionCntryCd: state => {
      state.trmsCd = {};
    },
    getTermsVersionFail: () => {},
  },
});

export const {
  getNationList,
  getNationListSuccess,
  getTermsContents,
  getTermsContentsSuccess,
  getPrivacyPolicy,
  getPrivacyPolicySuccess,
  getCountryTerms,
  getCountryTermsSuccess,
  setResidenceCntry,
  setTermsEpid,
  getTermsPolicy,
  getTermsPolicySuccess,
  getTermsPolicyFail,
  setCurrentVersion,
  createTermsAgreement,
  createTermsAgreementSuccess,
  updatePrivacy,
  updatePrivacySuccess,
  updatePrivacyFail,
  getTermsVersionCntryCd,
  getUseTermsVersion,
  getUseTermsVersionSuccess,
  getUseTerms,
  getUseTermsSuccess,
} = termsSlice.actions;
export default termsSlice.reducer;
